import { render, staticRenderFns } from "./ExpandIcon.vue?vue&type=template&id=5986da2a"
import script from "./ExpandIcon.vue?vue&type=script&lang=ts"
export * from "./ExpandIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports